
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/watch/[watchId]",
      function () {
        return require("private-next-pages/live/watch/[watchId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/watch/[watchId]"])
      });
    }
  